import React from 'react';
import Navigation from '../components/shared/Navigation';

const creditBundles = [
  {
    name: 'Starter Pack',
    price: 199,
    credits: 200,
    bonus: null,
    popular: false,
  },
  {
    name: 'Value Pack',
    price: 499,
    credits: 600,
    bonus: 100,
    popular: true,
  },
  {
    name: 'Power Pack',
    price: 999,
    credits: 1300,
    bonus: 300,
    popular: false,
  },
  {
    name: 'Pro Pack',
    price: 1999,
    credits: 2800,
    bonus: 800,
    popular: false,
  },
];

const features = [
  'Transparent pricing – No hidden fees',
  'Scalable – Buy credits as your business grows',
  'Startup-friendly – Designed for Indian SMEs & creators',
  'Free to start – 200 credits on signup, no credit card needed',
];

const PricingPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navigation />
      <div className="pt-20">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-[#1d2840] mb-2">Super Owl Credit Bundles 🇮🇳</h1>
            <p className="text-lg text-gray-700 mb-8">
              Use credits to chat with Super Owl AI, access premium tools, and more.<br />
              <strong className="text-[#3DA3DC]">🎁 200 free credits on signup!</strong>
            </p>
            <div className="flex flex-wrap justify-center gap-8 mb-10">
              {creditBundles.map((bundle, idx) => (
                <div
                  key={bundle.name}
                  className={`bg-white rounded-xl shadow-lg w-64 p-6 transition duration-300
                    ${bundle.popular ? 'border-2 border-[#007bff] relative' : 'border border-gray-200'}
                    hover:shadow-xl hover:-translate-y-1`}
                >
                  {bundle.popular && (
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#007bff] text-white px-4 py-1 rounded-full text-xs font-semibold">
                      Most Popular
                    </div>
                  )}
                  <h2 className="text-xl font-bold mb-2">{bundle.name}</h2>
                  <div className="price text-2xl text-green-600 font-bold mb-2">₹{bundle.price}</div>
                  <div className="credits text-base mb-1">{bundle.credits} Credits</div>
                  {bundle.bonus && (
                    <div className="bonus text-sm text-[#007bff] mb-1">+{bundle.bonus} Bonus Credits</div>
                  )}
                  <button className="btn mt-3 bg-black text-white px-5 py-2 rounded-full font-semibold">
                    Buy Now
                  </button>
                </div>
              ))}
            </div>
            <p className="note text-sm text-gray-600 mb-8">
              💬 1 Credit = 1 Chat Interaction or AI Feature Use • 🎯 Credits never expire
            </p>
            <div className="features text-left max-w-xl mx-auto">
              <h2 className="text-xl font-bold mb-3">Why Super Owl Pricing?</h2>
              <ul className="list-none pl-0 text-base">
                {features.map((feature, idx) => (
                  <li key={idx} className="mb-3 pl-6 relative">
                    <span className="absolute left-0">✅</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingPage;
